const roles = {
    Unknown: -1,
    Admin: 1,
    Partner: 2,
    Customer: 3,
    Measurer: 5,
};

export default roles;
